import type { CSSProperties } from "react";

export const tokens = {
  /* Accent */
  accent: "oklch(58% 0.22 345)" /* ~#c44478 */,
  accentLight: "oklch(96% 0.04 345)",
  accentMid: "oklch(88% 0.08 345)",
  accentDark: "oklch(40% 0.20 345)",
  accentBtn: "linear-gradient(135deg, oklch(56% 0.22 340), oklch(46% 0.20 300))",

  /* Sidebar */
  sidebarBg:
    "linear-gradient(160deg, #0d1020 0%, #16102e 25%, #22103a 48%, #3a1040 68%, #5e1848 84%, #842254 100%)",

  /* Surfaces */
  bgMain: "#fdf9f8",
  bgCard: "#ffffff",
  bgInput: "#fdf6f7",

  /* Bordures */
  border: "#f0e4e8",
  borderInput: "#e8d8dc",

  /* Texte */
  textMain: "#1e0d18",
  textSub: "#b0909a",
  textLabel: "#c0a0a8",

  /* États */
  success: "oklch(62% 0.16 155)",
  error: "oklch(58% 0.22 25)",
  warning: "oklch(72% 0.16 75)",
} as const;

export const shadows = {
  card: "0 1px 8px rgba(100,20,50,.06), 0 0 0 1px rgba(240,180,200,.20)",
  btnPrimary: "0 2px 8px oklch(56% 0.22 340 / .28)",
} as const;

export const radius = {
  card: 14,
  input: 9,
  badge: 20,
} as const;

/* Rétrocompatibilité avec les autres onglets */
export const colors = {
  primary: "#c44478",
  primaryDark: "oklch(40% 0.20 345)",
  text: "#1e0d18",
  textSecondary: "#b0909a",
  textTertiary: "#c0a0a8",
  border: "#f0e4e8",
  borderLight: "#faf0f3",
  background: "#fdf9f8",
  white: "#ffffff",
  success: "oklch(62% 0.16 155)",
  successBg: "oklch(96% 0.04 155)",
  warning: "oklch(72% 0.16 75)",
  warningBg: "oklch(96% 0.04 75)",
  info: "oklch(58% 0.22 345)",
  infoBg: "oklch(96% 0.04 345)",
} as const;

export const inputStyle: CSSProperties = {
  width: "100%",
  padding: "9px 13px",
  borderRadius: radius.input,
  border: `1px solid ${tokens.borderInput}`,
  fontSize: 13,
  fontFamily: "'DM Sans', 'IBM Plex Sans', system-ui, sans-serif",
  color: tokens.textMain,
  background: tokens.bgInput,
  transition: "all 0.15s ease",
  outline: "none",
};

export const labelStyle: CSSProperties = {
  display: "block",
  fontSize: 10.5,
  fontWeight: 700,
  color: tokens.textLabel,
  marginBottom: 6,
  textTransform: "uppercase",
  letterSpacing: "0.6px",
};

export const cardStyle: CSSProperties = {
  background: tokens.bgCard,
  borderRadius: radius.card,
  border: `1px solid ${tokens.border}`,
  boxShadow: shadows.card,
  overflow: "hidden",
};

export const buttonPrimary: CSSProperties = {
  padding: "9px 20px",
  borderRadius: 8,
  border: "none",
  background: tokens.accentBtn,
  boxShadow: shadows.btnPrimary,
  color: "#ffffff",
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
  transition: "opacity 0.15s ease",
  fontFamily: "'DM Sans', 'IBM Plex Sans', system-ui, sans-serif",
};

export const buttonSecondary: CSSProperties = {
  padding: "9px 20px",
  borderRadius: 8,
  border: `1px solid ${tokens.borderInput}`,
  background: tokens.bgCard,
  color: "#907080",
  fontSize: 13,
  fontWeight: 500,
  cursor: "pointer",
  transition: "all 0.15s ease",
  fontFamily: "'DM Sans', 'IBM Plex Sans', system-ui, sans-serif",
};

export const pageContainerStyle: CSSProperties = {
  maxWidth: 1200,
  margin: "0 auto",
  padding: "24px 32px 40px",
  fontFamily: "'DM Sans', 'IBM Plex Sans', system-ui, sans-serif",
  color: tokens.textMain,
  background: tokens.bgMain,
  minHeight: "100vh",
};

export const transmissionSectionTitleStyle: CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  color: tokens.textSub,
  marginBottom: 12,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
};

export const pastilleActivatedStyle: CSSProperties = {
  padding: "6px 12px",
  borderRadius: 8,
  fontSize: 12,
  fontWeight: 600,
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  background: colors.successBg,
  color: colors.success,
};

export const transmissionSidebarFolderLabelStyle: CSSProperties = {
  ...labelStyle,
};
